import { observer } from 'mobx-react-lite';
import { EventQueueRowData, UnitQueueRowData } from '../../../socket/stream-types';
import { TimeCell } from '../../../queues/components/cells/common/time-cell';
import { getEventQueueRowData } from '../../../queues/utils/get-event-queue-row-data';

export const TimeTransmittedCell = observer(function TimeTransmittedCell({
    data,
}: {
    data: EventQueueRowData | UnitQueueRowData;
}): React.ReactElement {
    return <TimeCell dateStr={getEventQueueRowData(data)?.timeTransmitted} />;
});
